module.exports = __webpack_public_path__ + "static/media/Green-Line-Juliet-Pitts.85e5f3fc.m4v";